import _ from 'lodash';
import parseItemNo from './parseItemNo';

const itemFilter = (queries) => {
  const parsedQueries = queries.map((query) => query.ItemNo ? { ...query, ItemNo: parseItemNo(query.ItemNo) } : query);
  return (item) => _.some(parsedQueries, (query) => _.keys(query).every((key) => query[key] === item[key]));
};

export default itemFilter;
